import "./FiltrationFundamentals.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import FiltrationHero from "./sections/FiltrationHero";
import FiltrationPrinciplesTechnicalGuide from "./sections/FiltrationPrinciplesTechnicalGuide";
import EngineeringConsultationCta from "./sections/EngineeringConsultationCta";
import Footer from "@/reusable_sections/Footer";
export default function FiltrationFundamentalsPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="FiltrationFundamentals" />
      <FiltrationHero />
      <FiltrationPrinciplesTechnicalGuide />
      <EngineeringConsultationCta />
      <Footer />
    </div>;
}